export default __webpack_public_path__ + "static/media/tools.483abca9.webp";